// extracted by mini-css-extract-plugin
module.exports = {"PanelRatingPlace":"Top_PanelRatingPlace__Aqv-i"};